(() => {
  const RETURN_STATE_KEY = 'lchCollectionReturn';
  const SNAPSHOT_CLASS = 'lch-history-snapshot';
  const PRODUCT_LINK_SELECTOR =
    '#ProductGridContainer a[href*="/products/"], #product-grid a[href*="/products/"]';
  let productNavigationStarted = false;

  const currentUrlKey = () => `${window.location.pathname}${window.location.search}`;

  const getReturnState = () => {
    try {
      return window.history.state?.[RETURN_STATE_KEY] || null;
    } catch (_error) {
      return null;
    }
  };

  const isHistoryReturn = (event) => {
    if (event?.persisted) return true;

    const navigation = window.performance?.getEntriesByType?.('navigation')?.[0];
    return navigation?.type === 'back_forward';
  };

  const saveCollectionPosition = (link) => {
    let destination;
    try {
      destination = new URL(link.href, window.location.href);
    } catch (_error) {
      return;
    }

    if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) return;

    const marker = {
      url: currentUrlKey(),
      x: window.scrollX,
      y: window.scrollY,
      savedAt: Date.now(),
    };

    try {
      window.history.replaceState(
        { ...(window.history.state || {}), [RETURN_STATE_KEY]: marker },
        '',
        window.location.href
      );
      productNavigationStarted = true;
      document.documentElement.classList.add(SNAPSHOT_CLASS);
    } catch (_error) {
      // Navigation must remain usable even when history storage is unavailable.
    }
  };

  const restoreCollectionPosition = (event) => {
    const marker = getReturnState();
    if (!marker || marker.url !== currentUrlKey() || !isHistoryReturn(event)) {
      document.documentElement.classList.remove(SNAPSHOT_CLASS);
      return;
    }

    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    document.documentElement.classList.add(SNAPSHOT_CLASS);

    const restore = () => window.scrollTo(marker.x || 0, marker.y || 0);
    restore();
    window.requestAnimationFrame(() => window.requestAnimationFrame(restore));
    window.setTimeout(restore, 120);
    window.setTimeout(() => {
      restore();
      document.documentElement.classList.remove(SNAPSHOT_CLASS);
    }, 350);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const link = event.target.closest?.(PRODUCT_LINK_SELECTOR);
      if (link) saveCollectionPosition(link);
    },
    true
  );

  window.addEventListener('pagehide', () => {
    if (productNavigationStarted) document.documentElement.classList.add(SNAPSHOT_CLASS);
  });

  window.addEventListener('pageshow', (event) => {
    productNavigationStarted = false;
    restoreCollectionPosition(event);
  });

  restoreCollectionPosition();
})();
